/**
 * Temporary banner: shown ONLY when users access via the Emergent fallback
 * URL while smartkick.co.uk is being repaired. Auto-hides on the real domain
 * and after the user dismisses it.
 */
import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export default function FallbackDomainBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const host = window.location.hostname;
    const dismissed = localStorage.getItem('fallback_banner_dismissed') === '1';
    // Show only on non-smartkick.co.uk and when not previously dismissed
    if (!dismissed && !host.endsWith('smartkick.co.uk')) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem('fallback_banner_dismissed', '1');
    } catch (e) {
      // Ignore quota / private-mode errors
    }
  };

  return (
    <div
      data-testid="fallback-domain-banner"
      style={{
        background: 'linear-gradient(90deg,#f59e0b,#f97316)',
        color: '#0b0b0d',
        padding: '10px 16px',
        fontSize: '13px',
        fontWeight: 600,
        textAlign: 'center',
        position: 'relative',
        zIndex: 999,
      }}
    >
      <span>
        You're on our temporary URL — <strong>smartkick.co.uk</strong> is being repaired.
        Everything works the same here. Bookmark this page for now! ⚽
      </span>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        data-testid="dismiss-fallback-banner"
        style={{
          position: 'absolute',
          right: '8px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          color: '#0b0b0d',
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
}
